import { Store } from 'vuex';
import AbstractHandler from '@/language/handlers/AbstractHandler';
import Handler from '@/language/handlers/Handler';
import RootState from '@/store/RootState';
import store from '@/store';
import Language from '@/language/Language';

export default class LocalizedLocationsHandler extends AbstractHandler {
    private store: Store<RootState>;
    constructor(nextHandler?: Handler) {
        super(nextHandler);

        this.store = store;
    }

    handle(language: Language): void {
        this.store.dispatch('locations/fetch');

        super.handle(language);
    }
}
